import { get, filter, find, map, isEmpty } from 'lodash/fp';
import { createSelector } from '@reduxjs/toolkit';
import { toStringFqn } from 'app/lib/utils';
import { selectCurrentProjectId, selectProjects } from 'app/store/projects';
import { selectSnowflakeSchemas } from 'app/store/snowflake/selectors';

const selectSlice = get('tableDetails');
const selectTableDetailsByFqn = createSelector(selectSlice, get('byFqn'));

export const selectTableDetailsForSnowflakeLocations = createSelector(
    selectSlice,
    selectSnowflakeSchemas,
    (details, snowflakeSchemas) => {
        const result = [];
        Object.values(snowflakeSchemas).forEach(
            ({ sources }) =>
                !isEmpty(sources) &&
                Object.values(sources).forEach(({ fqn }) =>
                    details.byFqn[fqn] ? result.push(details.byFqn[fqn]) : null
                )
        );
        return result;
    }
);

const selectPropFqn = (_, props) => props.fqn;
export const selectTableDetailsByPropFqn = createSelector(
    selectTableDetailsByFqn,
    selectPropFqn,
    (tables, fqn) => (fqn ? tables?.[toStringFqn(fqn)] : null)
);

const selectReferencesByTableFqn = createSelector(selectSlice, get('projectReferencesByTableFqn'));
export const selectReferencesForPropFqn = createSelector(
    selectPropFqn,
    selectReferencesByTableFqn,
    selectCurrentProjectId,
    (fqn, referencesByFqn, currentProjectUid) =>
        filter(({ spaceUid }) => spaceUid !== currentProjectUid, referencesByFqn[toStringFqn(fqn)])
);

export const selectReferencesSlugsForPropFqn = createSelector(
    selectReferencesForPropFqn,
    (references) => map(({ slug }) => slug, references)
);

export const selectOriginProjectByPropFqn = createSelector(
    selectProjects,
    selectTableDetailsByPropFqn,
    (projects, tableDetails) => {
        const projectUid = tableDetails?.createdInProject;

        return find({ uid: projectUid }, projects);
    }
);

const selectDownstreamReferencesByTableFqn = createSelector(
    selectSlice,
    get('downstreamReferencesByTableFqn')
);
export const selectDownstreamReferencesForPropFqn = createSelector(
    selectPropFqn,
    selectDownstreamReferencesByTableFqn,
    (fqn, referencesByFqn) => referencesByFqn[toStringFqn(fqn)] ?? []
);
